export default __webpack_public_path__ + "static/media/light@2.9ae5a08b.png";